module.exports = __webpack_public_path__ + "media/images/map-7812538d55b6827527f237d8348f880f.svg";